/** @format */

import * as React from 'react';
//@ts-ignore
import { StyleSheet, View, InteractionManager, Platform } from 'react-native';
//@ts-ignore
import { observer } from 'mobx-react';
//@ts-ignore
import { JDDevice, JDText } from '@jdreact/jdreact-core-lib';
import InfoTitle from './InfoTitle';
import Store from '../services/goodsContrastPageStore/store';
import Loading from './Loading';
import { IAttributeVo } from '../services/goodsContrastPageStore/domain';
const { getRpx } = JDDevice;
const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  main: {
    paddingLeft: getRpx(37),
    paddingTop: getRpx(38),
  },
  commonLine: {
    width: 1,
    height: getRpx(40),
    backgroundColor: '#F2F2F2',
    marginLeft: getRpx(35),
  },
  paramsItem: {
    justifyContent: 'space-between',
    width: getRpx(322),
    paddingLeft: getRpx(35),
  },
  mainItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  mainInfo: {
    marginBottom: getRpx(30),
  },
  mainTitle: {
    color: '#262626',
    fontSize: getRpx(30),
    height: getRpx(42),
    lineHeight: getRpx(42),
    fontWeight: 'bold',
    marginBottom: getRpx(16),
  },
  mainList: {
    flexDirection: 'row',
  },
  block: {
    width: '100%',
    height: getRpx(24),
    backgroundColor: '#F2F2F2',
  },
  normalText: {
    maxWidth: getRpx(250),
    lineHeight: getRpx(37),
  },
});

interface IStoreProps {
  store: {
    tabCtrlIndex: number;
    golbalSku: string;
    attributeTab: {
      groupName: string;
      attributeVoList: IAttributeVo[];
    }[];
    SamePropsCheck: boolean;
  };
}
interface IProps extends IStoreProps {
  isReadOnly: boolean;
  index: number;
}
interface state {
  attributeTab:
    | null
    | {
        groupName: string;
        attributeVoList: IAttributeVo[];
      }[];
}
class TabConBasicParams extends React.PureComponent<IProps, state> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      attributeTab: null,
    };
  }
  componentDidMount() {
    const { store } = this.props;
    const { attributeTab } = store;
    setTimeout(() => {
      InteractionManager.runAfterInteractions(() => {
        this.setState({ attributeTab: attributeTab.slice(0, Math.floor(attributeTab.length / 3)) }, () => {
          setTimeout(() => {
            InteractionManager.runAfterInteractions(() => {
              this.setState({ attributeTab: attributeTab });
            });
          }, 100);
        });
      });
    }, 0);
  }
  UNSAFE_componentWillReceiveProps(nextProps: any) {
    if (nextProps.store.attributeTab) {
      this.setState({ attributeTab: nextProps.store.attributeTab });
    }
  }
  render() {
    const { store, index } = this.props;
    const { SamePropsCheck, tabCtrlIndex } = store;
    const { attributeTab } = this.state;
    let hideSame = SamePropsCheck && tabCtrlIndex === index;
    if (!attributeTab) {
      return (
        <View style={{ height: getRpx(500) }}>
          <Loading />
        </View>
      );
    }
    return (
      <View style={styles.wrap}>
        {attributeTab &&
          attributeTab.map((prop, index) => {
            return (
              <>
                {hideSame && !prop.attributeVoList.some((v) => v.hideFlag === false) ? null : (
                  <View style={styles.main} key={prop.groupName}>
                    {hideSame && prop.attributeVoList.map((attr) => attr.hideFlag).indexOf(false) == -1 ? null : (
                      <InfoTitle title={prop.groupName} marginBottom={32} />
                    )}
                    {prop.attributeVoList.map((attr) => {
                      return (
                        <>
                          {hideSame && attr.hideFlag ? null : (
                            <View style={styles.mainInfo}>
                              <View key={attr.attributeName}>
                                <JDText style={styles.mainTitle}>{attr.attributeName}</JDText>
                                <View style={styles.mainList}>
                                  {attr.attributeValueVos.map((value, idx) => {
                                    return (
                                      <View style={[styles.mainItem, styles.paramsItem]}>
                                        <JDText style={styles.normalText}>{value ? value : '-'}</JDText>
                                        {idx !== attr.attributeValueVos.length - 1 ? (
                                          <View style={styles.commonLine}></View>
                                        ) : null}
                                      </View>
                                    );
                                  })}
                                </View>
                              </View>
                            </View>
                          )}
                        </>
                      );
                    })}
                  </View>
                )}

                {hideSame && !prop.attributeVoList.some((v) => v.hideFlag === false) ? null : (
                  <>{index !== attributeTab.length - 1 ? <View style={styles.block}></View> : null}</>
                )}
              </>
            );
          })}
      </View>
    );
  }
}
const TabConBasicParamsOberver = observer(TabConBasicParams);
const TabConBasicParamsWapper = (props: IProps) => <TabConBasicParamsOberver {...props} store={Store} />;
export default TabConBasicParamsWapper;
